/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-button-footer[_ngcontent-%COMP%]{display:flex;margin-top:15px}.modal-button-footer[_ngcontent-%COMP%]   .btn-primary[_ngcontent-%COMP%]{flex:2}.modal-button-footer[_ngcontent-%COMP%]   .btn-light[_ngcontent-%COMP%]{flex:1;background-color:#dedede;border-color:#dedede}.modal-button-footer[_ngcontent-%COMP%]   .btn-block[_ngcontent-%COMP%] + .btn-block[_ngcontent-%COMP%]{margin-left:10px;margin-top:0}"];
export { styles as styles };
